/*!

=========================================================
* Argon Design System React - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-design-system-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-design-system-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";
import { createStore, applyMiddleware, compose } from 'redux';
import { Provider } from 'react-redux'
import ReduxThunk from 'redux-thunk'
import axios from 'axios';
import {API_URL} from './network';
import { routerMiddleware } from 'connected-react-router';
import { createHashHistory } from 'history';

import createRootReducer from './reducers/index.js';
import 'material-icons/iconfont/material-icons.css';

import "assets/vendor/nucleo/css/nucleo.css";
import "assets/vendor/font-awesome/css/font-awesome.min.css";
import "assets/scss/argon-design-system-react.scss?v1.1.0";
//admin
import Orders from "views/Admin/Orders.js"
import Requests from  "views/Admin/Requests.js"
import EditOrderAdmin from "views/Admin/EditOrder.js"
import EditQuoteAdmin from "views/Admin/EditQuote"
import UploadProductAdmin from "views/Admin/UploadProduct"
import SettingAdmin from "views/Admin/Setting"

import Accounts from "views/Admin/Accounts.js"

//user
import Myorders from "views/Myorders.js";
import Myrequests from "views/Myrequests.js";
import Landing from "views/examples/Landing.js";
import Login from "views/Login.js";
import Profile from "views/examples/Profile.js";
import Register from "views/Register.js";
import Forgot from  "views/Forgot.js";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import AddOrder from "views/AddOrder";
import EditOrder from "views/EditOrder";
import Myaccount from "views/Myaccount";
import HowToOrder from "views/HowToOrder";
import ViewOrder from "views/ViewOrder";
import EditQuote from "views/EditQuote";
import ViewQuote from "views/ViewQuote";
import ViewCatalogues from "views/ViewCatalogues"
import QuoteMange from "views/Admin/QuoteMange";
import Accept from "views/Accept.js";
import Reject from "views/Reject.js";
import packageJson from '../package.json';

console.log(
  `%cBigBrand Portal`,
  "font-size:16px;font-weight:700;color:#fff;"
);
console.log(
  `%cVersion: ${packageJson.version}`,
  "color:#2563eb;font-weight:600;"
);
console.log("index.js API_URL: =========>", API_URL);

const history = createHashHistory();

export function getHistory() {
  return history;
}
if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {

}
else{
  if (window.location.protocol !== 'https:') {
    console.log("redirect to https");
    window.location.replace(`https:${window.location.href.substring(window.location.protocol.length)}`);
  }
}

axios.defaults.baseURL = API_URL;
axios.defaults.headers.common['Content-Type'] = "multipart/form-data";
const token = localStorage.getItem('token_bigbrand');
if (token) {
    axios.defaults.headers.common['Authorization'] = "Bearer " + token;
}  
else{
  // window.location.href = "/";
}

// axios.interceptors.request.use(
//   config => {

//       if (token) {
//           config.headers['Authorization'] = "Bearer " + token;
//       }
//       config.headers['Content-Type'] = 'multipart/form-data';
      
//       return config;
//   },
//   error => {
//       // Promise.reject(error)
//   });

axios.interceptors.response.use((response) => {
    return response
}, function (error) {
    const originalRequest = error.config;

    if (error.response.status === 401 ) {
      localStorage.removeItem('token_bigbrand');
      localStorage.removeItem('user_bigbrand');
      axios.defaults.headers.common['Authorization'] = "";
      window.location.href = "/login-page";
    }
    return error;
});

const user = localStorage.getItem('user_bigbrand');
var role="";
if(user && user != undefined){
  var userinfo = JSON.parse(user)
  role = userinfo['role']
}

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
export const store = createStore(
  createRootReducer(history),
  composeEnhancers(
    applyMiddleware(
      routerMiddleware(history),
      ReduxThunk
    ),
  )
);

const CloseButton = ({closeToast}) => <i onClick={closeToast} className="la la-close notifications-close"/>
let isLogged = localStorage.getItem('token_bigbrand');
ReactDOM.render(
  <Provider store={store}>
    <ToastContainer
        autoClose={5000}
        hideProgressBar
        closeButton={<CloseButton/>}
    />
    <BrowserRouter>
      {isLogged &&
      <Switch>
        <Route path="/" exact render={props => <Login {...props} />} />
        <Route
          path="/landing-page"
          exact
          render={props => <Landing {...props} />}
        />
        <Route path="/login-page" exact render={props => <Login {...props} />} />
        <Route
          path="/profile-page"
          exact
          render={props => <Profile {...props} />}
        />
        <Route
          path="/register-page"
          exact
          render={props => <Register {...props} />}
        />
        <Route
          path="/forgot"
          exact
          render={props => <Forgot {...props} />}
        />
        
        <Route
          path="/catalogues"
          exact
          render={props => <ViewCatalogues {...props} />}
        />
        
        
        <Route
          path="/myaccount"
          exact
          render={props => <Myaccount {...props} />}
        />
         <Route
          path="/howtoorder"
          exact
          render={props => <HowToOrder {...props} />}
        />
        <Route path="/accept" render={props => <Accept {...props} />} />
        <Reject path="/reject" render={props => <Reject {...props} />} /> 
        
        { role!="admin" &&
        <>        
        <Route
          path="/admin"
          render={props => <Redirect to="/" />}
        />
        <Route
          path="/myorders"
          exact
          render={props => <Myorders status="all" {...props} />}
        />
        <Route
          path="/requests"
          exact
          render={props => <Myrequests status="request" {...props} />}
        />
        <Route
          path="/requests/add"
          exact
          render={props => <AddOrder {...props} />}
        />
        <Route
          path="/myorders/edit/:id"
          exact
          render={props => <EditQuote {...props} />}
        />
        <Route
          path="/myorders/view/:id"
          exact
          render={props => <ViewOrder {...props} />}
        />
        
        <Route
          path="/requests/edit/:id"
          exact
          render={props => <EditQuote {...props} />}
        />
        <Route
          path="/requests/view/:id"
          exact
          render={props => <ViewQuote {...props} />}
        />
        
        </>
        }
        { role=="admin" &&
        <>
        
         {/* redirect client to admin  start*/}
          <Route
            path="/myorders/edit/:id"
            exact
            render={props => <Redirect to={`/admin/myorders/edit/${props.match.params.id}`} />}
          />
          <Route
            path="/myorders/view/:id"
            exact
            render={props => <Redirect to={`/admin/myorders/edit/${props.match.params.id}`} />}
          />
          
          <Route
            path="/requests/edit/:id"
            exact
            render={props => <Redirect to={`/admin/requests/edit/${props.match.params.id}`} />}
          />
          <Route
            path="/requests/view/:id"
            exact
            render={props => <Redirect to={`/admin/requests/view/${props.match.params.id}`} />}
          />
          
         {/* redirect client to admin  end*/}

          <Route
            path="/admin/all_accounts"
            exact
            render={props => <Accounts {...props} />}
          />
          <Route
            path="/admin/quote_manager"
            exact
            render={props => <QuoteMange status="all" {...props} />}
          />
          <Route
            path="/admin/myorders"
            exact
            render={props => <Orders status="all" {...props} />}
          />
          <Route
            path="/admin/requests"
            exact
            render={props => <Requests status="request" {...props} />}
          />
          <Route
            path="/admin/myorders/edit/:id"
            exact
            render={props => <EditQuoteAdmin {...props} />}
          />
          <Route
            path="/admin/myorders/view/:id"
            exact
            render={props => <EditQuoteAdmin {...props} />}
          />          
          <Route
            path="/admin/requests/add"
            exact
            render={props => <AddOrder {...props} />}
          />
          <Route
            path="/admin/requests/edit/:id"
            exact
            render={props => <EditQuoteAdmin {...props} />}
          />
          <Route
            path="/admin/uploadproduct"
            exact
            render={props => <UploadProductAdmin {...props} />}
          />
          <Route
            path="/admin/setting"
            exact
            render={props => <SettingAdmin {...props} />}
          />
        </>
        }
        <Redirect to="/" />
      </Switch>
      }
      
      {
        (!isLogged||isLogged==undefined)&&
        <Switch>         
          
          <Route path="/accept" render={props => <Accept {...props} />} />
          <Reject path="/reject" render={props => <Reject {...props} />} /> 
          <Route
            path="/register-page"
            exact
            render={props => <Register {...props} />}
          />
          <Route
            path="/forgot"
            exact
            render={props => <Forgot {...props} />}
          />
          <Route path="/login-page" exact render={props => <Login {...props} />} />
          <Redirect to="/login-page" />
        </Switch>
      }
    </BrowserRouter>
  </Provider>,
  document.getElementById("root")
);
